import { Box } from "@mui/material";
import React from "react";
import MissionCard from "./MissionCard";

export default function MissionTab() {
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        paddingX: "8px",
      }}
    >
      <MissionCard />
      <MissionCard />
      <MissionCard />
      <MissionCard />
    </Box>
  );
}
